import { Component } from '@angular/core';

@Component({
  selector: 'default-mobile-app',
  templateUrl: './mobile-app.component.html',
  styleUrls: []
})
export class MobileAppComponent {
}
